import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { LanguageProvider } from './i18n/LanguageContext';
render(<LanguageProvider data-id="element-566" data-mp="1wbcwbpsgz7d8">
    <App data-id="element-567" data-mp="21a7gav26b1yx" />
  </LanguageProvider>, document.getElementById('root'));